import { BrowserModule } from '@angular/platform-browser'
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HttpClientModule } from '@angular/common/http'
import { MatDialogModule } from '@angular/material/dialog'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { L10nConfig, L10nIntlModule, L10nLoader, L10nTranslationModule } from 'angular-l10n'

import { Error404Component } from './pages/error/404/error-404.component'
import { CustomMarkdownDirective } from './directives/custom-markdown.directives'
import { LoaderComponent } from './components/loader/loader.component'
import { ServiceWorkerModule } from '@angular/service-worker'
import { LogoutComponent } from './pages/logout/logout.component'
import { RedirectSsoComponent } from './pages/redirect-sso/redirect-sso.component'
import { ApplicationComponent } from './pages/application/application.component'
import { ConsoleModule } from './components/console/console.module'
import { ConfirmDialogModule } from './dialog/confirm-dialog/confirm-dialog.module'
import { ModalModule } from './external/modal'
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker'
// @ts-ignore@
import fr from '../assets/l10n/language-fr-FR.json'
// @ts-ignore
import us from '../assets/l10n/language-en-US.json'
// @ts-ignore
import gb from '../assets/l10n/language-en-GB.json'
import { LbPipesModule } from '@affluences/lb-utils-front'
import {CopyToClipboardDirective} from './directives/copy-to-clipboard.directive';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

export const l10nConfig: L10nConfig = {
    format: 'language-region',
    providers: [
        {
            name: 'app',
            asset: {
                'fr-FR': fr,
                'en-US': us,
                'en-GB': gb,
                'it-IT': us,
                'es-ES': us,
                'nl-NL': us,
                'de-DE': us,
                'pt-PT': us,
                'tr-TR': us,
                'ru-RU': us,
                'zh-CN': us,
                'zh-TW': us,
                'ja-JP': us,
                'ko-KR': us,
                'th-TH': us
            }
        }
    ],
    cache: false,
    keySeparator: '.',
    defaultLocale: { language: 'fr-FR', currency: 'EUR', timeZone: 'Europe/Paris' },
    schema: [
        { locale: { language: 'fr-FR', currency: 'EUR' }, dir: 'ltr', text: 'France' },
        { locale: { language: 'en-US', currency: 'USD' }, dir: 'ltr', text: 'United States' },
        { locale: { language: 'it-IT', currency: 'EUR' }, dir: 'ltr', text: 'Italia' },
        { locale: { language: 'es-ES', currency: 'EUR' }, dir: 'ltr', text: 'Spain' },
        { locale: { language: 'nl-NL', currency: 'EUR' }, dir: 'ltr', text: 'Netherlands' },
        { locale: { language: 'de-DE', currency: 'EUR' }, dir: 'ltr', text: 'Germany' },
        { locale: { language: 'pt-PT', currency: 'EUR' }, dir: 'ltr', text: 'Portugal' },
        { locale: { language: 'en-GB', currency: 'GBP' }, dir: 'ltr', text: 'United Kingdom' },
        { locale: { language: 'tr-TR', currency: 'TRY' }, dir: 'ltr', text: 'Turkey' },
        { locale: { language: 'ru-RU', currency: 'RUB' }, dir: 'ltr', text: 'Russia' },
        { locale: { language: 'zh-CN', currency: 'CNY' }, dir: 'ltr', text: 'China' },
        { locale: { language: 'zh-TW', currency: 'CNT' }, dir: 'ltr', text: 'Traditional Chinese' },
        { locale: { language: 'ja-JP', currency: 'JPY' }, dir: 'ltr', text: 'Japan' },
        { locale: { language: 'ko-KR', currency: 'KRW' }, dir: 'ltr', text: 'South Korea' },
        { locale: { language: 'th-TH', currency: 'THB' }, dir: 'ltr', text: 'Thailand' }
    ]
}

export function initL10n ( l10nLoader: L10nLoader ): () => Promise<void> {
    return () => l10nLoader.init().catch( ( err ) => {
        console.log( 'Error on loading translations configuration : %o', err )
    } )
}

@NgModule( {
    declarations: [
        AppComponent,
        Error404Component,
        CustomMarkdownDirective,
        LoaderComponent,
        LogoutComponent,
        RedirectSsoComponent,
        ApplicationComponent
    ],
    imports: [
        L10nTranslationModule.forRoot(l10nConfig),
        L10nIntlModule,
        BrowserModule,
        HttpClientModule,
        FormsModule,
        NgxMaterialTimepickerModule,
        AppRoutingModule,
        ConfirmDialogModule,
        LbPipesModule,
        ConsoleModule,
        MatDialogModule,
        BrowserAnimationsModule,
        MatSnackBarModule,
        ModalModule,
        ServiceWorkerModule.register('./ngsw-worker.js', { enabled: true })
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initL10n,
            deps: [L10nLoader],
            multi: true
        },
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline' },
        }
    ],
    bootstrap: [AppComponent]
} )
export class AppModule {
}
